webpackJsonp([4],{

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(638),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3081d9b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = examinePass;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateLastProblemUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDshProblemByID;
/* harmony export (immutable) */ __webpack_exports__["b"] = getProblemByGuidManager;
/* harmony export (immutable) */ __webpack_exports__["f"] = checkAnswerByGuid;
/* harmony export (immutable) */ __webpack_exports__["g"] = getProblemByGuid;
/* harmony export (immutable) */ __webpack_exports__["h"] = getNextProblemGuid;
/* unused harmony export uploadProblemImg */
/* harmony export (immutable) */ __webpack_exports__["e"] = editProblemByGuid;
/* harmony export (immutable) */ __webpack_exports__["a"] = deltetPreProblemById;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function examinePass(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/examinePass',
    data: data,
    method: 'post'
  });
}

function updateLastProblemUser(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/updateLastProblemUser',
    data: data,
    method: 'post'
  });
}

function getDshProblemByID(id) {
  console.log('api---id=' + id);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getDshProblemByID',
    params: {
      id: id
    },
    method: 'get'
  });
}

function getProblemByGuidManager(guid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getProblemByGuidManager',
    params: {
      guid: guid
    },
    method: 'get'
  });
}

function checkAnswerByGuid(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/checkAnswerByGuid',
    data: data,
    method: 'post'
  });
}

function getProblemByGuid(guid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getProblemByGuid',
    params: {
      guid: guid
    },
    method: 'get'
  });
}

function getNextProblemGuid(guid, passtype) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getNextProblemGuid',
    params: {
      guid: guid,
      passtype: passtype
    },
    method: 'get'
  });
}

function uploadProblemImg(formdata) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/uploadProblemImg',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 10000,
    data: formdata
  });
}

function editProblemByGuid(guid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/editProblemByGuid',
    data: guid,
    method: 'post'
  });
}

function deltetPreProblemById(id) {
  console.log('api deltetPreProblemById  id =' + id);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/deltetPreProblemById',
    data: id,
    method: 'post'
  });
}

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(396);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var ExamineProblemDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(500));

var instance = void 0;

var examineProblemDlg = function examineProblemDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new ExamineProblemDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  instance.vm.dshid = options.dshid;
  instance.vm.isEditData = options.isEditData;
  instance.vm.guid = options.guid;
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (examineProblemDlg);

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_quill_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_knowledge_js__ = __webpack_require__(101);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      loading: false,
      tempstr: '',
      showEditBtn: false,
      type: '0',
      guid: '',
      dshid: -1,
      isEditData: false,
      pInfo1: {
        id: 0,
        guid: '',
        type1: '',
        type2: '',
        type3: '',
        type4: '',
        main: 1,
        minor: 1,
        aisnumber: '',
        aformat: '',
        keyword: '',
        title: '',
        content: '',
        atype: '',
        amark: '',
        aselect: '',
        answer: '',
        rank: 0,
        author2: '',
        animateJSNames: ''
      },
      kInfo: {
        guid: '',
        title: '',
        type: '',
        content: '',
        author2Guid: '',
        description: '',
        keyword2: ''
      },
      toolbarOptions: [[{ 'table': ['newtable_1_1', 'newtable_1_2', 'newtable_1_3', 'newtable_1_4', 'newtable_1_5', 'newtable_2_1', 'newtable_2_2', 'newtable_2_3', 'newtable_2_4', 'newtable_2_5', 'newtable_3_1', 'newtable_3_2', 'newtable_3_3', 'newtable_3_4', 'newtable_3_5'] }], [{ 'table': 'append-row' }], [{ 'table': 'append-col' }], [{ 'table': 'remove-row' }], [{ 'table': 'remove-col' }], [{ 'table': 'remove-table' }], [{ 'table': 'cell-background' }], ['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], ['link', 'image'], ['formula', 'clean', 'video']],
      quill: null
    };
  },

  computed: {
    title: function title() {
      if (this.isEditData === true) {
        this.showEditBtn = true;
      } else {
        this.showEditBtn = false;
      }
      return '\u5BA1\u6838\u9898\u76EE-' + (this.isEditData === true ? '修改' : '新增');
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.markDown();
      }
    }
  },
  methods: {
    markDown: function markDown() {
      var _this = this;

      setTimeout(function () {
        var options = {
          modules: {
            formula: true,
            syntax: true,
            toolbar: {
              container: _this.toolbarOptions,
              handlers: {
                image: _this.imageHandler
              }
            }
          },
          scrollingContainer: '#standalone-container',
          placeholder: 'Compose an epic...',
          theme: 'snow'
        };

        if (!_this.quill) {
          _this.quill = new window.Quill('#editor', options);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_quill_table__["setEditor"])(_this.quill);
        }
        _this.loadData();
      }, 1000);
    },
    closeDlg: function closeDlg() {
      this.show = false;
    },
    imageHandler: function imageHandler() {
      console.log('65');
      var range = this.quill.getSelection();
      var value = prompt('What is the image URL');
      this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER);
    },
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '审核题目',
        message: msg,
        type: type
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      if (this.isEditData === true) {
        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["b" /* getProblemByGuidManager */])(this.guid).then(function (res) {
          var data = res.data;
          if (data.isOk) {
            _this2.pInfo1 = data.data[0];
            var tm = JSON.parse(_this2.pInfo1.content);
            console.log(tm.ops);
            if (_this2.quill) {
              _this2.quill.setContents(tm.ops);
              _this2.quill.enable(true);
            } else {
              console.log('quill初始化失败。');
            }
          } else {
            _this2.showMsg('获取题目信息失败，请关闭修改对话框后重新再试！');
          }
          _this2.loading = false;
        }).catch(function (err) {
          _this2.showMsg(err);
          _this2.loading = false;
        });
      } else {
        this.loading = true;
        console.log('this.dshid==' + this.dshid);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["c" /* getDshProblemByID */])(this.dshid).then(function (res) {
          var data = res.data;
          if (data.isOk) {
            _this2.pInfo1 = data.data[0];
            var tm = JSON.parse(_this2.pInfo1.content);
            console.log(tm.ops);
            if (_this2.quill) {
              _this2.quill.setContents(tm.ops);
              _this2.quill.enable(true);
            } else {
              console.log('quill初始化失败。');
            }
          } else {
            _this2.showMsg('获取题目信息失败，请关闭修改对话框后重新再试！');
          }
          _this2.loading = false;
        }).catch(function (err) {
          _this2.showMsg(err);
          _this2.loading = false;
        });
      }
    },
    examine1: function examine1() {
      var _this3 = this;

      console.log('审核通过并创建新题目，this.pInfo1=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.pInfo1));
      this.pInfo1.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quill.getContents());
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["d" /* examinePass */])(this.pInfo1).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this3.showMsg('创建新题目成功。', 'info');
          } else {
            _this3.showMsg('创建新题目失败。', 'info');
          }
        } else {
          _this3.showMsg('创建新题目不成功。', 'info');
        }
      }).catch(function (err) {
        _this3.showMsg('\u4FDD\u5B58\u65B0\u9898\u5931\u8D25\u3002' + err);
      });
    },
    saveEdit: function saveEdit() {
      var _this4 = this;

      console.log('修改题目 this.pInfo1=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.pInfo1));
      this.pInfo1.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quill.getContents());
      console.log('this.pInfo1.content=' + this.pInfo1.content);
      delete this.pInfo1['id'];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["e" /* editProblemByGuid */])(this.pInfo1).then(function (res) {
        if (res.data) {
          console.log('修改题目 res.data=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
          if (res.data.isOk === true) {
            _this4.showMsg('修改新题目成功。', 'info');
          } else {
            _this4.showMsg('修改新题目失败。', 'info');
          }
        } else {
          _this4.showMsg('修改新题目不成功。', 'info');
        }
      }).catch(function (err) {
        _this4.showMsg('\u4FEE\u6539\u65B0\u9898\u5931\u8D25\u3002' + err);
      });
    },
    testCheckAnswer: function testCheckAnswer() {
      var _this5 = this;

      var answerInfo = {};
      answerInfo.answer = 'B';
      answerInfo.pmain = 1;
      answerInfo.passtype = 2;
      answerInfo.pguid = '5d64c6f08bd511e787c68980854367e6';
      answerInfo.pminor = 1;
      console.log('anwserInfo1=', answerInfo);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["f" /* checkAnswerByGuid */])(answerInfo).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this5.showMsg('checkAnswerByGuid1。', 'info');
          } else {
            _this5.showMsg('checkAnswerByGuid2。', 'info');
          }
        } else {
          _this5.showMsg('checkAnswerByGuid3。', 'info');
        }
      }).catch(function (err) {
        _this5.showMsg('checkAnswerByGuid4\u3002' + err);
      });
    },
    testGetProblemGuids: function testGetProblemGuids() {
      var _this6 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["g" /* getProblemByGuid */])(this.guid).then(function (res) {
        var data = res.data;
        console.log('--data--', data);
        if (data.isOk) {} else {
          _this6.showMsg('获取题目GUID失败！');
        }
      });
    },
    testGetNextProblemGuids: function testGetNextProblemGuids() {
      var _this7 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["h" /* getNextProblemGuid */])(this.guid, 1).then(function (res) {
        var data = res.data;
        console.log('--data--', data);
        if (data.isOk) {} else {
          _this7.showMsg('获取题目GUID失败！');
        }
      });
    },
    updateLastProblemU: function updateLastProblemU() {
      var _this8 = this;

      var level = {};
      level.pmain = this.pInfo1.main;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["i" /* updateLastProblemUser */])(level).then(function (res) {
        _this8.showMsg(res.data);
      });
    },
    commit2knowledge: function commit2knowledge() {
      var _this9 = this;

      this.kInfo.title = this.pInfo1.title;
      this.kInfo.content = this.pInfo1.content;
      this.kInfo.type = this.pInfo1.type1;
      this.kInfo.author2Guid = this.pInfo1.author2;
      this.kInfo.keyword2 = this.pInfo1.keyword2;
      this.kInfo.description = this.pInfo1.description;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_api_knowledge_js__["e" /* addNewKnowledge */])(this.kInfo).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this9.showMsg('添加知识点成功。', 'info');
          } else {
            _this9.showMsg('添加知识点失败。', 'info');
          }
        } else {
          _this9.showMsg('添加知识点不成功。', 'info');
        }
      }).catch(function (err) {
        _this9.showMsg('\u6DFB\u52A0\u77E5\u8BC6\u70B9\u5931\u8D25\u3002' + err);
      });
    }
  }
});

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".h20{height:20px}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/components/examineProblemDlg/src/main.vue"],"names":[],"mappings":"AACA,KACE,WAAa,CACd","file":"main.vue","sourcesContent":["\n.h20{\n  height: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(420);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("8a274478", content, true);

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(503),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "pInfo1",
    attrs: {
      "model": _vm.pInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "guid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid,修改时用"
    },
    model: {
      value: (_vm.pInfo1.guid),
      callback: function($$v) {
        _vm.pInfo1.guid = $$v
      },
      expression: "pInfo1.guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "归类1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "显示到最上方的类别"
    },
    model: {
      value: (_vm.pInfo1.type1),
      callback: function($$v) {
        _vm.pInfo1.type1 = $$v
      },
      expression: "pInfo1.type1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "归类2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备用，尚未用到"
    },
    model: {
      value: (_vm.pInfo1.type2),
      callback: function($$v) {
        _vm.pInfo1.type2 = $$v
      },
      expression: "pInfo1.type2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "关键词"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "会显示到类别1的下方"
    },
    model: {
      value: (_vm.pInfo1.keyword),
      callback: function($$v) {
        _vm.pInfo1.keyword = $$v
      },
      expression: "pInfo1.keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "此处文字会显示到正文中，可写可不写，最好写上"
    },
    model: {
      value: (_vm.pInfo1.title),
      callback: function($$v) {
        _vm.pInfo1.title = $$v
      },
      expression: "pInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "原作者"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原作者"
    },
    model: {
      value: (_vm.pInfo1.author2),
      callback: function($$v) {
        _vm.pInfo1.author2 = $$v
      },
      expression: "pInfo1.author2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案类型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "0为输入，1为单选题，2为多选题"
    },
    model: {
      value: (_vm.pInfo1.atype),
      callback: function($$v) {
        _vm.pInfo1.atype = $$v
      },
      expression: "pInfo1.atype"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案标记"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "即显示在输入答案前的提示，同时也是选择题选项"
    },
    model: {
      value: (_vm.pInfo1.amark),
      callback: function($$v) {
        _vm.pInfo1.amark = $$v
      },
      expression: "pInfo1.amark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案是否数值"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "数值为1，字符为0，逗号分隔，，如果是多个输入，需要全写，如三个是1,1,1"
    },
    model: {
      value: (_vm.pInfo1.aisnumber),
      callback: function($$v) {
        _vm.pInfo1.aisnumber = $$v
      },
      expression: "pInfo1.aisnumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案格式"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案格式，如输入一个整数，输入一个字符，输入一个小数，保留两位小数等，多个用逗号分隔"
    },
    model: {
      value: (_vm.pInfo1.aformat),
      callback: function($$v) {
        _vm.pInfo1.aformat = $$v
      },
      expression: "pInfo1.aformat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案"
    },
    model: {
      value: (_vm.pInfo1.answer),
      callback: function($$v) {
        _vm.pInfo1.answer = $$v
      },
      expression: "pInfo1.answer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "主题号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "主题号，知识点大题号"
    },
    model: {
      value: (_vm.pInfo1.main),
      callback: function($$v) {
        _vm.pInfo1.main = $$v
      },
      expression: "pInfo1.main"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "次题号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "次题号，知识点内小题号"
    },
    model: {
      value: (_vm.pInfo1.minor),
      callback: function($$v) {
        _vm.pInfo1.minor = $$v
      },
      expression: "pInfo1.minor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "等级点"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "等级变化点，24k为1，23k为2，22k为3...."
    },
    model: {
      value: (_vm.pInfo1.rank),
      callback: function($$v) {
        _vm.pInfo1.rank = $$v
      },
      expression: "pInfo1.rank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "keyword2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的keywords，尽量多填"
    },
    model: {
      value: (_vm.pInfo1.keyword2),
      callback: function($$v) {
        _vm.pInfo1.keyword2 = $$v
      },
      expression: "pInfo1.keyword2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的description，尽量多填"
    },
    model: {
      value: (_vm.pInfo1.description),
      callback: function($$v) {
        _vm.pInfo1.description = $$v
      },
      expression: "pInfo1.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "动画JS名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "只写名称如12k_pid_6,forward_1等，不加.js，多个用逗号分隔"
    },
    model: {
      value: (_vm.pInfo1.animateJSNames),
      callback: function($$v) {
        _vm.pInfo1.animateJSNames = $$v
      },
      expression: "pInfo1.animateJSNames"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDlg
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.showEditBtn) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_vm._v("保存修改")]) : _vm._e(), _vm._v(" "), (_vm.type == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.examine1
    }
  }, [_vm._v("创建新题目，审核通过")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "center"
    }
  }, [(_vm.type == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateLastProblemU
    }
  }, [_vm._v("更新已做到最后一题的用户")]) : _vm._e(), _vm._v(" "), (_vm.type == 0) ? _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.commit2knowledge
    }
  }, [_vm._v("提交本题到知识点")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("题目内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "10px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "calc(100vh - 220px)"
    },
    attrs: {
      "id": "editor"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_examineProblemDlg__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__ = __webpack_require__(375);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cols: [{
        prop: 'id',
        label: 'id',
        width: 80
      }, {
        prop: 'type1',
        label: '类别1',
        width: 150
      }, {
        prop: 'type2',
        label: '类别2',
        width: 150
      }, {
        prop: 'title',
        label: '标题',
        width: 150
      }, {
        prop: 'keyword',
        label: '关键词',
        width: 150
      }, {
        prop: 'amark',
        label: '答案标记',
        width: 150
      }, {
        prop: 'aformat',
        label: '答案格式',
        width: 150
      }, {
        prop: 'answer',
        label: '答案',
        width: 150
      }]
    };
  },

  props: ['tableData'],
  computed: {
    tabH: function tabH() {
      return this.winH - (this.search ? this.search.getHeight() : 80) - 88;
    }
  },
  methods: {
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '审核题目',
        message: msg,
        type: type
      });
    },
    edit: function edit(id) {
      console.log('examineProblemDlg->edit id = ', id);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_examineProblemDlg__["a" /* default */])({
        isEditData: false,
        dshid: id
      });
    },
    del: function del(id) {
      var _this = this;

      console.log('delete id=' + id);
      var data = {};
      data.id = id;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["a" /* deltetPreProblemById */])(data).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this.showMsg('成功删除，请刷新更新。', 'info');
          } else {
            _this.showMsg('删除待审核题目失败。', 'info');
          }
        } else {
          _this.showMsg('删除待审核题目失败', 'info');
        }
      }).catch(function (err) {
        _this.showMsg('\u5220\u9664\u5F85\u5BA1\u6838\u9898\u76EE\u5931\u8D25' + err);
      });
    }
  }
});

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prepareProblemTable_prepareProblemTable__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prepareProblemTable_prepareProblemTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_prepareProblemTable_prepareProblemTable__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['dshProblemList'])),
  created: function created() {
    this.$store.dispatch('actions_getDshProblemList');
  },

  components: {
    prepareProblemTable: __WEBPACK_IMPORTED_MODULE_2__components_prepareProblemTable_prepareProblemTable___default.a
  },
  methods: {}
});

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"prepareProblemTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".ctitle[data-v-3081d9b8]{height:56px;width:100%;text-align:center}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/prepareProblemList.vue"],"names":[],"mappings":"AACA,yBACE,YAAa,AACb,WAAY,AACZ,iBAAmB,CACpB","file":"prepareProblemList.vue","sourcesContent":["\n.ctitle[data-v-3081d9b8]{\n  height: 56px;\n  width: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("67923ff6", content, true);

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(571);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("0f409bb5", content, true);

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(630),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 630:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "height": _vm.tabH
    }
  }, [_vm._l((_vm.cols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "show-overflow-tooltip": ""
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "审核",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "del",
    attrs: {
      "label": "删除",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('prepare-problem-table', {
    attrs: {
      "tableData": _vm.dshProblemList
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctitle"
  }, [_c('h2', [_vm._v("待审核题目")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.0c5c872c58b2dfbd33b3.js